/**
 * Home Page Widget Registry.
 *
 * Pure WidgetType -> widget mapping for the home PL pipeline. The home page's primary widget is the
 * generic HOMEPAGE_BANNER (HERO_BANNER / HERO_CAROUSEL / MULTIPLE_HERO_BANNERS, keyed off displayType).
 * Shared content/marketing widgets are reused from the same registry CLP/PDP use; home-specific widgets
 * (CATEGORIES_SHOWCASE, FEATURED_PRODUCTS_SHOWCASE) are integrated as they migrate to PL.
 */

import { WidgetType } from '@lastbrand/storefront-proto-registry/api/v1/enums'

import { asBaseWidget, PageWidgetRegistry } from '@src/components/pl-base-widget'
import { BackToSchoolWidget } from '@src/components/widgets/back-to-school'
import { CategoriesShowcaseWidget } from '@src/components/widgets/categories-showcase'
import { CollectionBannerWidget } from '@src/components/widgets/collection-banner'
import { FeatureCardsWidget } from '@src/components/widgets/feature-cards'
import { HomepageBannerWidget } from '@src/components/widgets/homepage-banner'
import { MediaTextMosaicWidget } from '@src/components/widgets/media-text-mosaic'
import { RichTextWidget } from '@src/components/widgets/rich-text'
import { TrustBadgesWidget } from '@src/components/widgets/trust-badges'

export function getWidgetRegistry(): PageWidgetRegistry {
  return {
    // Generic homepage banner: one widget renders all three banner section types based on displayType.
    [WidgetType.HOMEPAGE_BANNER]: asBaseWidget(HomepageBannerWidget),
    // Shared content/marketing widgets (self-contained, render from their own WidgetData).
    [WidgetType.COLLECTION_BANNER]: asBaseWidget(CollectionBannerWidget),
    [WidgetType.MEDIA_TEXT_MOSAIC]: asBaseWidget(MediaTextMosaicWidget),
    [WidgetType.FEATURE_CARDS]: asBaseWidget(FeatureCardsWidget),
    [WidgetType.TRUST_BADGES]: asBaseWidget(TrustBadgesWidget),
    [WidgetType.RICH_TEXT]: asBaseWidget(RichTextWidget),
    // Homepage-specific widgets.
    [WidgetType.CATEGORIES_SHOWCASE]: asBaseWidget(CategoriesShowcaseWidget),
    [WidgetType.FEATURED_PRODUCTS_SHOWCASE]: asBaseWidget(BackToSchoolWidget),
  }
}
